<hr />
<h2 class="mb-4">Billing Information</h2>

<h6 class="mb-4 ms-4 payment-blurb">
  This information is used to process the payment for multiple orders.<br>
  It will be used on the receipt, but the billing information on the individual orders will not be updated.
</h6>

<ng-container [formGroup]="form">

  <div id="address-book-wrapper" class="my-4">
    <app-address-book (addressChosen)="loadAddress($event)"></app-address-book>
  </div>

  <div class="mt-2">
    <div class="row">
      <div class="col-5 mb-3">
        <label for="firstName" class="required">First Name</label>
        <input appScrText placeholder="First Name" id="firstName" [formControlName]="'billingFirstName'"
          #billingFirstName maxlength="{{MaxLen.FirstName}}" appFirstNameValidator required />
        <app-error-msg [fg]="form" [fieldName]="'billingFirstName'" fieldLabel="First Name"></app-error-msg>
      </div>
      <div class="col-5 mb-3">
        <label for="lastName" class="required">Last Name</label>
        <input appScrText placeholder="Last Name" id="lastName" formControlName="billingLastName" #billingLastName
          maxlength="{{MaxLen.LastName}}" appLastNameValidator required />
        <app-error-msg [fg]="form" [fieldName]="'billingLastName'" fieldLabel="Last Name"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-3 mb-3">
        <label for="billingPhoneInput" class="required">Phone Number</label>
        <app-phone required #billingPhone class="col-12" formControlName="billingPhone" id="billingPhone"></app-phone>
        <app-error-msg [fg]="form" fieldName="billingPhone" fieldLabel="Phone Number"></app-error-msg>
      </div>
      <div class="col-2 mb-3">
        <label for="billingPhoneExtension">Extension</label>
        <input appScrText id="billingPhoneExtension" formControlName="billingPhoneExtension" maxlength="{{MaxLen.PhoneExtension}}">
      </div>
    </div>
    <div class="row">
      <div class="col-8 mb-3">
        <label for="billingEmail" class="required">Email</label>
        <input appScrText placeholder="Email" required appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" id="billingEmail" formControlName="billingEmail"
          #billingEmail maxlength="{{MaxLen.Email}}" />
        <app-error-msg [fg]="form" fieldName="billingEmail" fieldLabel="Email"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-4 mb-3">
        <label for="billingCountry" class="required">Country</label>
        <app-country-dropdown #country id="billingCountry" formControlName="billingCountry"></app-country-dropdown>
        <app-error-msg [fg]="form" fieldName="billingCountry" fieldLabel="Country"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-3">
        <label for="address1" class="required">Street Address 1</label>
        <input appScrText placeholder="Street Address 1" #address1 maxlength="{{MaxLen.Address}}"
          id="address1" formControlName="billingAddress1" required />
        <app-error-msg [fg]="form" fieldName="billingAddress1" fieldLabel="Street Address 1"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-3">
        <label for="address2">Street Address 2</label>
        <input appScrText placeholder="Street Address 2" #address2 maxlength="{{MaxLen.Address}}"
          id="address2" formControlName="billingAddress2" />
        <app-error-msg [fg]="form" fieldName="billingAddress2" fieldLabel="Street Address 2"></app-error-msg>
      </div>
    </div>
    <div class="row">
      <div class="col-4 mb-3">
        <label for="city" class="required">City</label>
        <input appScrText placeholder="City" #city maxlength="{{MaxLen.City}}"
          id="city" formControlName="billingCity" required />
        <app-error-msg [fg]="form" fieldName="billingCity" fieldLabel="City"></app-error-msg>
      </div>

      <div class="col-4 mb-3">
        <label for="state" [ngClass]="{required: form.controls.billingCountry.value === 'us' || form.controls.billingCountry.value === 'ca'}">
          State/Province
        </label>
        <app-region-dropdown [country]="form.controls.billingCountry.value" #state
          id="state" formControlName="billingState"></app-region-dropdown>
        <app-error-msg [fg]="form" fieldName="billingState" fieldLabel="State/Province"></app-error-msg>
      </div>
      
      <div class="col-4 mb-3">
        <label for="zipInput" [ngClass]="{required: form.controls.billingCountry.value === 'us' || form.controls.billingCountry.value === 'ca'}">
          Zip/Postal Code
        </label>
        <app-zipcode-input [country]="form.controls.billingCountry.value" #zip maxlength="{{MaxLen.Zip}}"
          inputId="zipInput" id="zip" formControlName="billingZip"></app-zipcode-input>
        <app-error-msg [fg]="form" fieldName="billingZip" fieldLabel="Zip/Postal Code"></app-error-msg>
      </div>
    </div>
  </div>

</ng-container>